import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as servers from '../../../../services/api/servers';
import {urls} from '../../../../services/api/urls';
import { GeneralServicesImplService } from "src/services/general-services-impl.service";
import { Observable } from "rxjs";
import { ProjectConstants } from "src/app/project-constants";

@Injectable({
    providedIn: 'root'
  })
  
export class ConsuntivoForecastScartoService extends GeneralServicesImplService{
    constructor(http: HttpClient) {
        super(http);
    }
    
    baseUrl: string = servers.apiUrl + urls.consuntivoForecastScartoController;

    getPage(filters: any, payload?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE;
    const body = payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post(url, body, {headers: header, responseType: 'json', params: filters})
        .pipe(
        // map (data => data) da inserire gestione errori
        );
    }
    
    
    getDownloadCsv(nameCsv: string) {
    const url = this.baseUrl + this.LINKS.DOWNLOAD_CSV + '/' + nameCsv;
    const body = null;
    const header = ProjectConstants.returnHeaderBlank();
    return this.http.get(url, {headers: header, responseType: 'text'})
        .pipe(
        // map (data => data) da inserire gestione errori
        );
    }
    
    getNameGenerateCsv(offset, payload: any) {
    const url = this.baseUrl + this.LINKS.GENERATE_CSV;
    const body = payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post(url, body, {headers: header, responseType: 'text', params: offset})
        .pipe(
        // map (data => data) da inserire gestione errori
        );
    
    }
    
    getNameGenerateXlsx(offset, payload: any) {
          const url = this.baseUrl + this.LINKS.GENERATE_XLSX;
          const body =  payload ? JSON.stringify(payload) : null;
          const header = ProjectConstants.returnGeneralHeader();
          return this.http.post( url, body, {headers: header, responseType: 'blob', params: offset})
            .pipe(
              // map (data => data) da inserire gestione errori
            );
    
        }
}